import React from "react";
import { Input } from "reactstrap";

export default function MessagesCell({ row, column, table, cell }) {
	const hiddenColumns = table.options.meta?.hiddenColumns;
	const columnId = cell.column.id;
	const isHidden = hiddenColumns && hiddenColumns.find((item) => item.id === columnId);

	const { mobileNumber } = row.original;
	const usersToNotify = table.options.meta?.usersToNotify || [];

	const isChecked = usersToNotify.some(u => u.adminId === row.original?.adminId);

	const handleChange = () => {
		table.options.meta?.updateUserData(row.original?.adminId, column.id, !isChecked);
		table.options.meta?.updateRecipientsArray(row.original);
	};

	if (isHidden) return <div className="ignore"></div>;

	return (
		<>
			{mobileNumber && (
				<Input
					type="checkbox"
					checked={isChecked}
					onChange={handleChange}
					className="planscreen__checkbox m-0"
				/>
			)}
		</>
	);
}
